// extracted by mini-css-extract-plugin
export default {"button--custom-color":"FacebookShareButton_button--custom-color__jV7tv"};